import angular from 'angular';
import parseCustom from 'App/resources/parsers/custom';

angular.module('upResources').service('ParseCustom', [
	function () {
		return parseCustom;
	}
]);
